/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContainerGraphEdgeDto
 */
export interface ContainerGraphEdgeDto {
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphEdgeDto
     */
    sourceEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphEdgeDto
     */
    sourceEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphEdgeDto
     */
    targetEntityType?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphEdgeDto
     */
    targetEntityId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContainerGraphEdgeDto
     */
    relationshipType?: string;
}

/**
 * Check if a given object implements the ContainerGraphEdgeDto interface.
 */
export function instanceOfContainerGraphEdgeDto(value: object): value is ContainerGraphEdgeDto {
    return true;
}

export function ContainerGraphEdgeDtoFromJSON(json: any): ContainerGraphEdgeDto {
    return ContainerGraphEdgeDtoFromJSONTyped(json, false);
}

export function ContainerGraphEdgeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerGraphEdgeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceEntityType': json['sourceEntityType'] == null ? undefined : json['sourceEntityType'],
        'sourceEntityId': json['sourceEntityId'] == null ? undefined : json['sourceEntityId'],
        'targetEntityType': json['targetEntityType'] == null ? undefined : json['targetEntityType'],
        'targetEntityId': json['targetEntityId'] == null ? undefined : json['targetEntityId'],
        'relationshipType': json['relationshipType'] == null ? undefined : json['relationshipType'],
    };
}

export function ContainerGraphEdgeDtoToJSON(json: any): ContainerGraphEdgeDto {
    return ContainerGraphEdgeDtoToJSONTyped(json, false);
}

export function ContainerGraphEdgeDtoToJSONTyped(value?: ContainerGraphEdgeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceEntityType': value['sourceEntityType'],
        'sourceEntityId': value['sourceEntityId'],
        'targetEntityType': value['targetEntityType'],
        'targetEntityId': value['targetEntityId'],
        'relationshipType': value['relationshipType'],
    };
}

